import axios from 'axios'
import widgetOptions from '../helpers/widget-options.js'

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT

const API = axios.create({
  baseURL: `${API_ENDPOINT}${widgetOptions.config.api_key}/v1/`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

export default API
